import { render, staticRenderFns } from "./incidences_by.vue?vue&type=template&id=02ef3a78"
import script from "./incidences_by.vue?vue&type=script&lang=js"
export * from "./incidences_by.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports